import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/mohit/Documents/Github/cp4d-managed/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In the event of an IBM declared Disaster, IBM will communicate with Client on an hourly basis as to the status of the recovery process, including progress regarding the Recovery Time Objective (RTO) and Recovery Point Objective (RPO).`}</p>
    <p>{`IBM will provide a projected RTO and RPO, based on the clients existing cloud service subscription, to perform recovery activities for Cloud Service Environment(s).`}</p>
    <p>{`An annual validated business continuity and disaster recovery test is included with the cloud service optional DR subscription.  Additional frequency testing and validation greater than on an annual basis can be performed under a separate Statement of Work for an additional charge.`}</p>
    <p>{`Please note if the Cloud Service Environment is designated as dev/test unavailability of the environment will be treated as a Severity 3 support case and
resolve the issue by way of restoring to the last known working backup or reinstalling.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      